import type { OrganizationPointDto } from "common/models/api/models/OrganizationPointDto";
import type { PointsFindByRequest } from "common/models/point/PointsFindByRequest";
import { UseQueryResult } from "react-query";
import { UseCustomQueryOptions } from "ui/query/react-query-overrides";
import usePointFindBy from "features/points/hooks/usePointFindBy";

export default function useGetPointCaducity(
    { organizationAddress }: Partial<PointsFindByRequest> = {},
    options: Omit<
        UseCustomQueryOptions<OrganizationPointDto, unknown, OrganizationPointDto["caducityDays"], (string | undefined)[]>,
        "select"
    > = {},
): UseQueryResult<OrganizationPointDto["caducityDays"]> {
    return usePointFindBy({ organizationAddress }, { select: (data) => data?.caducityDays, ...options });
}
